import {
	Alert,
	Card,
	Form,
	FormControl,
	FormText,
	Modal,
} from 'react-bootstrap';
//import jwt from 'jsonwebtoken';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { API, PHP } from '../utils/axiosConfig';
import { useAuth } from '../context/AuthContext';
import validateEmail from '../utils/validateEmail';

const LoginForm = ({ showLogin, setShowLogin }) => {
	const api = API();
	const php = PHP();
	const { login, logout, user, isAuthenticated } = useAuth();
	const [form, setForm] = useState({
		email: '',
		password: '',
		route: 'login',
	});
	const [errors, setErrors] = useState({});
	const [errorMessage, setErrorMessage] = useState('');
	const [forgotPassword, setForgotPassword] = useState(false);
	const [resetEmail, setResetEmail] = useState();
	const [resetError, setResetError] = useState();
	const [emailSuccess, setEmailSuccess] = useState();
	const [emailFailure, setEmailFailure] = useState();

	const handleForm = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	//validation for the login form
	const validateForm = () => {
		let errors = {};
		if (!form.email) {
			errors.email = 'Please provide Email.';
		} else {
			if (!validateEmail(form.email)) {
				errors.email = 'Please provide a valid Email.';
			}
		}
		if (!form.password) {
			errors.password = 'Please provide password';
		}

		setErrors({ ...errors });
		return Object.keys(errors).length === 0;
	};

	const handleLogin = (e) => {
		e.preventDefault();
		if (validateForm()) {
			if (form.email && form.password) {
				let formData = new FormData();
				formData.append('email', form.email);
				formData.append('password', form.password);
				formData.append('route', 'login');
				php
					.post('auth.php', formData)
					.then((res) => {
						if (res.status === 200) {
							console.log(res);
							login(res.data.user);
							closeAndClearForm();
						}
					})
					.catch((err) => {
						//unable to login, display error message
						logout();
						if (err.response.status === 401) {
							setErrorMessage(err.response.data.message);
						}
					});
			}
		}
	};

	//validation for the reset password form
	const validateResetForm = () => {
		let error;
		if (!resetEmail) {
			error = 'Please provide Email.';
		} else {
			if (!validateEmail(resetEmail)) {
				error = 'Please provide a valid Email.';
			}
		}

		setResetError(error);
		return Object.keys(errors).length === 0;
	};

	const handleReset = (e) => {
		e.preventDefault();
		if (validateResetForm()) {
			api
				.post('/auth/forgotPassword', { email: resetEmail })
				.then((res) => {
					if (res.status === 200) {
						setEmailSuccess(true);
					}
				})
				.catch((err) => {
					setEmailFailure(true);
				});
		}
	};

	const closeAndClearForm = () => {
		setShowLogin(false);
		setForm({
			email: '',
			password: '',
		});
		setErrorMessage('');
		setErrors({});
		setResetEmail('');
		setForgotPassword(false);
		setResetError();
		setEmailFailure(false);
		setEmailSuccess(false);
	};

	return (
		<Modal
			id="login-form"
			fullscreen="sm-down"
			show={showLogin}
			onHide={() => {
				closeAndClearForm();
			}}
			contentClassName="shadow-card"
		>
			<Modal.Header>
				{!forgotPassword ? (
					<h4 className="text-center flex-grow-1">Login</h4>
				) : (
					<h4 className="text-center flex-grow-1">Reset Password</h4>
				)}
			</Modal.Header>

			{!forgotPassword ? (
				<Form onSubmit={handleLogin}>
					<Modal.Body>
						<Form.Group>
							<Form.Label>Email:</Form.Label>
							<FormControl
								type="text"
								name="email"
								value={form.email}
								onChange={handleForm}
								isInvalid={errorMessage || errors.email}
							/>
							{errors.email && (
								<Form.Text className="text-center dangerColor">
									{errors.email}
								</Form.Text>
							)}
						</Form.Group>
						<Form.Group>
							<Form.Label>Password:</Form.Label>
							<FormControl
								type="password"
								name="password"
								value={form.password}
								onChange={handleForm}
								isInvalid={errorMessage || errors.password}
							/>
							{errors.password && (
								<Form.Text className="text-center dangerColor">
									{errors.password}
								</Form.Text>
							)}
						</Form.Group>
						{errorMessage && (
							<div className="text-center dangerColor">{errorMessage}</div>
						)}
						<div className="d-flex justify-content-end">
							<div
								className="text-end"
								id="forgot-password-link"
								onClick={() => setForgotPassword(true)}
							>
								Forgot Password
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button
							className="flex-grow-1"
							type="submit"
							name="login"
							variant="primary"
						>
							Login
						</Button>
					</Modal.Footer>
				</Form>
			) : !emailSuccess && !emailFailure ? (
				<Form onSubmit={handleReset}>
					<Modal.Body>
						<Form.Group>
							<Form.Label>Email:</Form.Label>
							<FormControl
								type="text"
								name="email"
								value={resetEmail}
								onChange={(e) => setResetEmail(e.target.value)}
								placeholder="Enter email to receive reset code."
								isInvalid={resetError}
							/>
							{resetError && (
								<Form.Text className="text-center dangerColor">
									{resetError}
								</Form.Text>
							)}
						</Form.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button
							className="flex-grow-1"
							type="submit"
							name="login"
							variant="primary"
						>
							Send Code
						</Button>
					</Modal.Footer>
				</Form>
			) : (
				<Modal.Body>
					{emailSuccess && (
						<Alert variant="success" className="text-center">
							Reset Code Sent.
						</Alert>
					)}
					{emailFailure && (
						<Alert variant="danger" className="text-center">
							Unable to send Reset Code. Please try again later.
						</Alert>
					)}
				</Modal.Body>
			)}
		</Modal>
	);
};
export default LoginForm;
